<template>
  <div class="userSettings">
    <div class="user-settings_menu" v-if="user.data">
      <div class="user-settings_menu-item"
           v-bind:class="{ 'user-settings_menu-item__active' : user.menu === 0 }"
           v-on:click="setUserMenu( 0 )">
        <div class="user-settings_menu-icon" v-if="user.data.is_verified">
          <img src="../assets/img/menu/user.svg" class="user-settings_menu-icon__white">
          <img src="../assets/img/menu/user_green.svg" class="user-settings_menu-icon__green">
        </div>
        <div class="user-settings_menu-icon user-settings_menu-icon tooltip" v-else>
          <img src="../assets/img/error.svg">
          <div class="tooltip-text">
            <div class="tooltip-text_cnt">
              Для дальнейшей корректной работы с системой Вам необходимо подтвердить свой e-mail
            </div>
          </div>
        </div>
        <div class="user-settings_user-name">
          <div>
            {{user.data.first_name}} {{user.data.last_name}}
          </div>
          <div class="text-small">
            {{user.data.email}}
          </div>
        </div>
        <button class="btn user-settings_logout" v-on:click="logout()">Выйти</button>
      </div>
      <div class="user-settings_menu-item"
           v-bind:class="{ 'user-settings_menu-item__active' : user.menu === 1 }"
           v-on:click="setUserMenu( 1 )">
        <div class="user-settings_menu-icon">
          <img src="../assets/img/menu/menu_icon_7.svg" class="user-settings_menu-icon__white">
          <img src="../assets/img/menu/menu_icon_7_green.svg" class="user-settings_menu-icon__green">
        </div>
        <div class="user-settings_user-name">
          Менеджер автопарка
        </div>
      </div>
      <div class="user-settings_menu-item"
           v-bind:class="{ 'user-settings_menu-item__active' : user.menu === 2 }"
           v-on:click="setUserMenu( 2 )">
        <div class="user-settings_menu-icon">
          <img src="../assets/img/menu/menu_icon_2.svg" class="user-settings_menu-icon__white">
          <img src="../assets/img/menu/menu_icon_2_green.svg" class="user-settings_menu-icon__green">
        </div>
        <div class="user-settings_user-name">
          Настройки оповещения о ТО
        </div>
      </div>
      <div class="user-settings_menu-item"
           v-bind:class="{ 'user-settings_menu-item__active' : user.menu === 3 }"
           v-on:click="setUserMenu( 3 )">
        <div class="user-settings_menu-icon">
          <img src="../assets/img/menu/menu_icon_3.svg" class="user-settings_menu-icon__white">
          <img src="../assets/img/menu/menu_icon_3_green.svg" class="user-settings_menu-icon__green">
        </div>
        <div class="user-settings_user-name">
          Сервисные отчеты
        </div>
      </div>
    </div>
    <div class="user-settings_footer">
      <button class="btn user-settings_logout" v-on:click="toggleInitialPage">Вернуться на сайт</button>
    </div>
  </div>
</template>

<script>
  import { HTTP_AUTH }      from  '../main'

  export default {
    data : function () {
      return{
      }
    },
    methods : {
      setUserMenu : function ( index ) {
        this.$store.dispatch('userMenu', index );
      },
      logout : function () {
        let _this = this;
        HTTP_AUTH.post('logout/').then(function () {
          document.cookie = 'userToken=;expires=Thu, 01 Jan 1970 00:00:01 GMT;';
          setTimeout(function () {
            window.location.reload();
          }, 100)
        }).catch(function (error){
          _this.$store.dispatch('errorResponse', error );
        });
      },
      toggleInitialPage : function () {
        this.$store.dispatch('toggleInitialPage');
      },
    },
    computed : {
      user : function(){
        return this.$store.state.user
      },
      initialPage: function(){
        return this.$store.state.initialPage;
      },
    },
    mounted(){
      if( !this.user.data ){
        HTTP_AUTH.get('user/').then((response) => {
          this.$store.dispatch('userData', response );
        }).catch(( error ) => {
          this.$store.dispatch('errorResponse', error );
        });
      }
    }
  }
</script>